import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function ExamTable({ subjects }) {
  const exams = Object.entries(subjects[0]);
  const ExameTableFiltered = exams.reduce((acc, [key, value]) => {
    if (!(value === null) && key?.startsWith('Exam')) {
      acc.push(`E${acc?.length + 1}`);
    }
    return acc;
  }, []);
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 2,
        borderRadius: 2,
        mt: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#f9fafb',
          borderRadius: 2,
          p: 2,
          border: '1px solid #e0e0e0',
          mt: 1,
        }}
      >
        <TableContainer>
          <Table
            size="small"
            sx={{
              borderCollapse: 'collapse',
              '& td, & th': {
                padding: '2px 8px',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>Subject</TableCell>
                <TableCell>Pre </TableCell>
                {ExameTableFiltered.map((h) => (
                  <TableCell key={h}>{h}</TableCell>
                ))}
                <TableCell>Post </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subjects?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row?.subject_name}</TableCell>
                  <TableCell>{row ? `${row?.pre_assessment_avg}%` : '--'}</TableCell>

                  {ExameTableFiltered.map((v, i) => (
                    <TableCell sx={{ maxWidth: 20 }} key={v}>
                      {row ? `${row?.[`Exam${i + 1}`]}%` : '-'}
                    </TableCell>
                  ))}
                  <TableCell>{row ? `${row?.post_assessment_avg}%` : '--'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
}
